import { useEffect, useMemo } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { Log, reportMenuItemsAtom, ReportsApi } from "@ryde/shared";

export const useReportMenuItems = () => {
  const [reportMenuItems, setReportMenuItems] =
    useRecoilState(reportMenuItemsAtom);

  const fetchReportMenuItems = useEvent(async (): Promise<void> => {
    const menuItemsResult = await ReportsApi.getReportsMenuItems();

    if (menuItemsResult?.success) {
      Log.debug("Report menu items received from api", menuItemsResult.data);
      setReportMenuItems(menuItemsResult.data || []);
    }
  });

  useEffect(() => {
    if (!reportMenuItems) {
      fetchReportMenuItems();
    }
  }, [fetchReportMenuItems, reportMenuItems, setReportMenuItems]);

  const reportMenuItemsFlattened = useMemo(() => {
    return reportMenuItems?.map(x => x.reportItems).flat() || [];
  }, [reportMenuItems]);

  return {
    fetchReportMenuItems,
    reportMenuItems,
    reportMenuItemsFlattened,
  };
};
